import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=eb294b60&scoped=true&lang=pug"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"
import style0 from "./Wallets.vue?vue&type=style&index=0&id=eb294b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb294b60",
  null
  
)

export default component.exports